package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.XtreamUtils
import com.xtream.data_kmp.db.dao.LiveCategoriesDao
import com.xtream.data_kmp.db.dao.LiveStreamsDao
import com.xtream.data_kmp.db.dao.SeriesCategoriesDao
import com.xtream.data_kmp.db.dao.SeriesStreamsDao
import com.xtream.data_kmp.db.dao.UserDao
import com.xtream.data_kmp.db.dao.VodCategoriesDao
import com.xtream.data_kmp.db.dao.VodStreamsDao
import com.xtream.data_kmp.dto.Account


class UserRepo (
    private val userDao: UserDao,
    private val liveStreamsDao: LiveStreamsDao,
    private val liveCategoriesDao: LiveCategoriesDao,
    private val vodStreamsDao: VodStreamsDao,
    private val vodCategoriesDao: VodCategoriesDao,
    private val seriesStreamsDao: SeriesStreamsDao,
    private val seriesCategoriesDao: SeriesCategoriesDao,



    ) {


    suspend fun login(account: Account) {
        val user = userDao.getLoggedInUser()
        if (user != null&& user.userInfo.username != account.userInfo.username) {
            logout()
        }
        account.isLoggedIn = true
        userDao.deleteAll()
        //Log.d("UserRepo", "All users Deleted")
        userDao.insert(account)
        //Log.d("UserRepo", "New User inserted")
    }

    suspend fun setAsLoggedIn(account: Account) {
        val user = userDao.getLoggedInUser()
        if (user != null&& user.userInfo.username != account.userInfo.username) {
            logout()
        }
        account.isLoggedIn = true
        userDao.deleteAll()
        //Log.d("UserRepo", "All users Deleted")
        userDao.insert(account)
        //Log.d("UserRepo", "New User inserted")
    }

    suspend fun logout() {

        userDao.logoutAllUsers()

        liveStreamsDao.deleteAll()
        liveCategoriesDao.deleteAll()
        vodStreamsDao.deleteAll()
        vodCategoriesDao.deleteAll()
        seriesStreamsDao.deleteAll()
        seriesCategoriesDao.deleteAll()

    }

    suspend fun getLastLoggedInUser(): Account? {
        return userDao.getLoggedInUser()
    }
    fun getLoggedInUserFlow() = userDao.getLoggedInUserFlow()

   suspend fun getUserServerUrl():String{
       return XtreamUtils.buildBaseUrl(getLastLoggedInUser()?.serverInfo)

    }

}